import { PROGRAMS } from '../../content/landing'
import { wrap } from '../layout.js'

/**
 * The programme strip under the hero — the landing page's answer to "what is
 * actually in there?", before the visitor has to take anything on faith.
 *
 * Wordmarks in the display face rather than logos: see `PROGRAMS` in
 * `content/landing.ts` for why.
 */
export function TrustStrip({ t, desktop }) {
  return (
    <section
      aria-labelledby="programs-title"
      style={{ ...wrap(desktop), paddingTop: desktop ? 56 : 40 }}
    >
      <h2
        id="programs-title"
        className="u-eyebrow"
        style={{ textAlign: 'center', marginBottom: desktop ? 24 : 18 }}
      >
        {t.programsTitle}
      </h2>
      <ul className="u-programs">
        {PROGRAMS.map((program) => (
          <li key={program}>{program}</li>
        ))}
      </ul>
    </section>
  )
}

export default TrustStrip
